import React from 'react'

export default function Divider(props){

    return(
        <div style = {{width:'100%', height:1,backgroundColor:'lightgrey',...props.style}} />
    )
}